<template>
    <div>
        <div style="border: 1px solid;">
            <div class="tit">
                <span>1</span>
                <span>填写excel发布标题</span>
            </div>

            <el-form style="padding:20px;">
                <el-form-item style="margin-bottom:0">
                    [{{vuex_userInfo.userName}}]{{lotteryName}}第（{{lotteryNo}}）期技巧师excel发布
                    <el-select v-model="select.value" placeholder="请选择">
                        <el-option v-for="(item,index) in select.arr" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <div>
                        是否有函数公式和10期缩水单或在本站上有10期以上原始记录
                        <el-button size="mini" @click="form.checked=!form.checked" :type="form.checked? 'primary' : ''">是</el-button>
                        <el-button size="mini" @click="form.checked=!form.checked" :type="!form.checked? 'primary' : ''">否</el-button>
                    </div>
                    <!-- <label>
						<el-checkbox v-model="form.checked">是否有函数公式和10期缩水单或在本站上有10期以上原始记录</el-checkbox>
					</label> -->
                </el-form-item>
            </el-form>
        </div>
        <div style="border: 1px solid;">
            <div class="tit">
                <span>2</span>
                <span>选择擅长的excel特定研究方向发布</span>
                <span style="margin-left:20px;color:gray;font-size:12px">温馨提示：每个类型不一定都发布，请选择自己擅长的</span>
            </div>
            <div style="padding:20px;">
                <div class="type lotteryType">
                    <div v-for="(item,index) in navDb.arr" :key="index" :class="{active:navDb.active==index}" @click="navDb.active=index;navDb.arr[navDb.active].cont_active = ''">{{item.label}}</div>
                </div>
                <hr style="border: 1px solid red">
                <div class="two_list">
                    <el-radio v-for="(item,index) in navDb.arr[navDb.active].cont" :key="index" v-model="navDb.arr[navDb.active].cont_active" :label="index" @change="changeNum(item,index)">{{lotteryName}}{{item}}</el-radio>
                </div>
            </div>
        </div>

        <div style="border: 1px solid;">
            <div class="tit">
                <span>3</span>
                <span>填到发布excel表</span>
            </div>

            <div class="selectList" style="padding:20px;">
                <div v-for="(item,index) in excelList" :key="index">
                    <span><b>名字:</b><b style="color:#2899DF;margin:0 10px">{{item.name}}</b> <b style="color:red">{{item.input}}</b> </span>
                    <div style="margin-top:10px;">
                        <div class="file">
                            <b>Excel文件名称:</b> {{ item.excel_release_excel }}
                            <div>
                                <el-button type="success" size="mini" :loading="item.excelLoading">上传</el-button>
                                <b style="color:red;margin-left:10px">*非必选项</b>
                                <input type="file" @change="inputChange($event,'excel_release_excel',item,'excelLoading')" />
                            </div>
                        </div>
                        <div class="file" v-if="[2,3].includes(item.mark)">
                            <b>txt文件名称:</b> {{item.excel_release_txt}}
                            <div>
                                <el-button type="success" size="mini" :loading="item.txtLoading">上传</el-button>
                                <b style="color:red;margin-left:10px">*非必选项</b>
                                <input type="file" @change="inputChange($event,'excel_release_txt',item,'txtLoading')" />
                            </div>
                        </div>
                        <div class="file">
                            <b>图片:</b>
                            <el-image v-if="item.excel_release_img" :preview-src-list="[item.excel_release_img]" :src="item.excel_release_img" style="width: 50px; height: 30px;border: 1px solid #000;margin-right: 10px;" alt="" />
                            <div>
                                <el-button type="success" size="mini" :loading="item.imgLoading">上传</el-button>
                                <b style="color:red;margin-left:10px">*非必选项</b>
                                <input type="file" @change="inputChange($event,'excel_release_img',item,'imgLoading')" />
                            </div>
                        </div>
                    </div>
                    <div>
                        <el-button type="primary" size="mini" @click="changeNum(item,index)">编辑</el-button>
                        <el-button type="danger" size="mini" @click="deleteItem(index)">删除</el-button>
                    </div>
                </div>
            </div>
        </div>

        <div class="textarea">
            <span>预测说明</span>
            <textarea name="" id="" cols="30" v-model="remark" rows="10" placeholder="温馨提示:没有永远正确的规律，规律始终在周期性的运动。自我评估本期自己图表截图的可靠性，当然想提高自己的被认购率还是要靠真实的成绩。"></textarea>
        </div>

        <div class="msg">注意:EXCEL表建议自己杀毒后再上传!一旦excel病毒扩散到我们的技术员电脑，将警告一次，并给予暂取消技巧师资格1个星期的处分。</div>

        <el-button type="primary" @click="confirmRelease">确认发布</el-button>

    </div>
</template>

<script>

import { ssq, dlt, fcsd, pls } from "./excel_release_options"

import mixin from './mixins'
import excelFabu from './common/excelFabu'
export default {
    mixins: [mixin, excelFabu],
    data () {
        return {
			navDb: pls,
            lotteryType: 4,
            preType: 3,
        };
    },
};
</script>

<style lang="scss" >
@import url(./common/style.scss);
.el-message-box {
    .el-message-box__message p {
        white-space: pre-line !important;
    }
}
</style>

<style lang="scss" scoped>
.el-radio {
    font-weight: bold;
}

.two_list {
    display: grid;
    font-size: 12px;
    margin-left: 20px;
    margin-top: 10px;
    gap: 15px;
}

.selectList {
    font-size: 12px;
    margin-top: 10px;

    > div {
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.3);

        &:last-child {
            border-bottom: 0;
            margin-bottom: 0;
            padding-bottom: 0;
        }

        .file {
            display: flex;
            align-items: center;
            column-gap: 10px;
            margin-bottom: 10px;

            > div {
                position: relative;

                input {
                    position: absolute;
                    inset: 0;
                    opacity: 0;
                }
            }
        }
    }
}

.uploadFile {
    display: flex;

    > div {
        border: 1px solid rgba(0, 0, 0, 0.1);
        margin-right: 20px;
        text-align: center;
        font-weight: bold;
        padding: 20px;
        font-size: 20px;
        cursor: pointer;

        input {
            margin-top: 10px;
            border: rgba(0, 0, 0, 0.1) solid 1px;
            padding: 10px;
            width: 80%;
        }
    }
}

.tit {
    background-color: #e9f6fd;
    padding: 10px;

    span:nth-child(1) {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        text-align: center;
        color: #fff;
        background-color: #409eff;
        font-style: italic;
        font-size: 15px;
        line-height: 20px;
        margin-right: 10px;
    }
}

.table {
    > div {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        text-align: center;

        span {
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-bottom: 0;
            padding: 10px;

            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &.del {
                cursor: pointer;
                color: red;
            }
        }
    }

    .th {
    }

    .td {
        border: 1px solid rgba(0, 0, 0, 0.1);

        > div {
            display: flex;
            justify-content: center;
            flex-direction: column;
        }
    }
}

.textarea {
    margin: 10px 0;
    display: flex;

    textarea {
        flex: 1;
        resize: none;
        margin-left: 10px;
    }
}

.msg {
    margin: 10px 0;
    color: #d36a24;
    white-space: nowrap;
}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
    /* 研究方向切换：允许换行铺满，不再横向溢出 */
    .lotteryType {
        flex-wrap: wrap;

        >div {
            flex: 1 1 auto;
            min-width: 78px;
            height: 42px;
            line-height: 42px;
            padding: 0 6px;
            font-size: 13px;
        }
    }

    /* 步骤标题：序号圆圈与文字对齐，温馨提示另起一行 */
    .tit {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        row-gap: 4px;

        span:nth-child(1) {
            vertical-align: middle;
            flex: none;
        }

        span:last-child {
            margin-left: 0 !important;
        }
    }

    /* 底部提示文字：换行显示，不再挤成一条超宽的线 */
    .msg {
        white-space: normal;
        line-height: 1.7;
    }

    /* 文件上传行：标签一行、按钮一行 */
    .selectList .file {
        flex-direction: column;
        align-items: flex-start;
        row-gap: 6px;
    }

    /* 预测说明：标签与文本框竖排 */
    .textarea {
        flex-direction: column;

        textarea {
            flex: none;
            margin-left: 0;
            margin-top: 8px;
            width: 100%;
        }
    }

    /* 单选列表：去掉左缩进 */
    .two_list {
        margin-left: 0;
    }

    /* 顶部表单：标题文字与下拉框分行，是/否按钮换行 */
    .el-form-item__content {
        white-space: normal;
    }

    .el-select {
        max-width: 100%;
        margin-top: 6px;
    }

    .el-form-item__content>div {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        row-gap: 8px;
    }
}
</style>